import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import styles from './SimilarListing.module.scss';
import api from '../../../context/api';
import ChatContext from '../../../context';
import SearchBar from '../../../common/SearchBar/SearchBar';

const SimilarListingContainer = ({ listingContainerToggle, sendListings }) => {
  const { portalId, userKind } = useContext(ChatContext);
  const [selectedListings, setSelectedListings] = useState([]);
  const [listings, setListings] = useState([]);
  const [filteredListings, setFilteredListings] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [allSelected, setAllSelected] = useState(false);
  const loadListings = () => {
    let pathToGet = `/listing/?agents=${portalId}`;
    if (userKind !== 'agent') {
      pathToGet = `/listing/?offices=${portalId}`;
    }
    api
      .get(pathToGet)
      .then(response => {
        const currentListings = response.data.results.map(listing => {
          listing.checked = false;
          return listing;
        });
        setFilteredListings([...currentListings]);
        setListings([...currentListings]);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const toggleSelectAll = () => {
    if (selectedListings.length === 0) {
      const selectAllListings = filteredListings.map(listing => {
        listing.checked = true;
        return listing;
      });
      const selectedAllListings = selectAllListings.map(listing => {
        return listing.id;
      });
      setAllSelected(true);
      setFilteredListings([...selectAllListings]);
      setSelectedListings([...selectedAllListings]);
    } else {
      filteredListings.map(listing => {
        listing.checked = false;
        return listing;
      });
      setAllSelected(false);
      setSelectedListings([]);
    }
  };

  const selectListing = (e, listing) => {
    if (e.target.checked) {
      listing.checked = true;
      setSelectedListings([...selectedListings, listing.id]);
    } else {
      listing.checked = false;
      const newSelectedListings = [...selectedListings].filter(
        selectedListing => selectedListing !== listing.id,
      );

      setSelectedListings([...newSelectedListings]);
    }
  };
  const SearchListings = () => {
    const listingSearch = listings.filter(
      listing =>
        (listing.id &&
          listing.id
            .toString()
            .toLowerCase()
            .includes(searchText)) ||
        (listing.propertyType && listing.propertyType.toLowerCase().includes(searchText)) ||
        (listing.address && listing.address.toLowerCase().includes(searchText)),
    );
    setFilteredListings([...listingSearch]);
  };

  const handleSearchChange = e => {
    setSearchText(e.target.value ? e.target.value.toLowerCase() : '');
  };

  const handleSendListings = () => {
    sendListings(selectedListings);
  };

  useEffect(() => {
    loadListings();
  }, []);

  useEffect(() => {
    SearchListings();
  }, [searchText]);

  return (
    <div className={styles.similarListingContainer}>
      <div className={styles.header}>
        <div className={styles.title}>Select and Share Properties</div>
        <div className={styles.close}>
          <button type="button" onClick={listingContainerToggle}>
            X
          </button>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.controls}>
          <div className={styles.searchBarCotnainer}>
            <SearchBar
              handleChange={handleSearchChange}
              placeholder="Search Property Type, Property ID, or Location"
            />
          </div>
          <div className={styles.actions}>
            <button type="button" className={styles.selectAllButton} onClick={toggleSelectAll}>
              {selectedListings.length === 0 ? 'Select All' : 'Unselect All'}
            </button>
            {selectedListings.length !== 0 ? (
              <button type="button" className={styles.sendButton} onClick={handleSendListings}>
                Send
              </button>
            ) : null}
          </div>
        </div>
        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <th>Photo</th>
                <th>
                  <strong>Property ID</strong>
                </th>
                <th>Property Type</th>
                <th>Listing Type</th>
                <th>
                  <strong>Price</strong>
                </th>
                <th>
                  <strong>Location</strong>
                </th>
                <th>Upload Date</th>
                <th width="120px">
                  <strong>{`${selectedListings.length} Selected`}</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredListings.map(listing => (
                <tr key={listing.id}>
                  <td>
                    <img
                      src={listing.images && listing.images[0] ? listing.images[0].url : ''}
                      alt=""
                    />
                  </td>
                  <td>{listing.id}</td>
                  <td>{listing.property_type}</td>
                  <td>{listing.listing_type}</td>
                  <td>{listing.display_price}</td>
                  <td>{listing.address}</td>
                  <td>{listing.created_at}</td>
                  <td>
                    <input
                      id={`select-listing-${listing.id}`}
                      type="checkbox"
                      checked={listing.checked}
                      onChange={e => selectListing(e, listing)}
                    />
                    <label htmlFor={`select-listing-${listing.id}`} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

SimilarListingContainer.propTypes = {
  listingContainerToggle: PropTypes.func.isRequired,
  sendListings: PropTypes.func.isRequired,
};

export default SimilarListingContainer;
